import { invokeApi } from "../../bl_libs/invokeApi";

export const messages_list_api = async (
  conversation_id,
  queryString,
  signal = null
) => {
  const requestObj = {
    path: `api/messages/${conversation_id}?${queryString}`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const read_messages_api = async (conversation_id) => {
  const requestObj = {
    path: `api/conversations/read_messages/${conversation_id}`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

export const save_message_api = async (message_id) => {
  const requestObj = {
    path: `api/saved_message/${message_id}`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

export const update_favorite_chats_api = async (conversation_id) => {
  const requestObj = {
    path: `api/conversations/update_favorite_chats/${conversation_id}`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

export const read_all_chats_api = async () => {
  const requestObj = {
    path: `api/conversations/read_all_chats`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

export const calls_list_api = async (data, signal = null) => {
  const page = data?.page ?? 0;
  const limit = data?.limit ?? 50;
  const requestObj = {
    path: `api/messages/calls_list?page=${page}&limit=${limit}`,
    method: "POST",
    postData: data,
    signal,
  };
  return invokeApi(requestObj);
};

export const translate_message_api = async (message_id) => {
  const requestObj = {
    path: `api/messages/message_translation/${message_id}`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

export const add_teachers_to_chat_api = async (data) => {
  const requestObj = {
    path: `api/conversations/add_teachers_to_chat`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const remove_teacher_from_chat_api = async (data) => {
  const requestObj = {
    path: `api/conversations/remove_teacher_from_chat`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};
